'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'feather-pointed';
var width = 512;
var height = 512;
var aliases = ["feather-alt"];
var unicode = 'f56b';
var svgPathData = 'M380.4 374.6C471.5 283.5 505.1 83.7 512 0 428.3 6.9 228.5 40.5 137.4 131.6l-7.3 7.5C57.3 217.3 57.1 304 71.3 356.4l2.4 7.3c5.4 14.3 14.5 26.9 25 38.2L.2 500.5 11.5 511.8 110 413.3c13.2 12.3 28.2 22.7 45.6 27.4l10.6 2.5c53 11.3 133.6 6.8 206.7-61.3l7.5-7.3zM121.3 402l66-66 204.9 0c-7.3 10-15 19.1-23.2 27.3-70.5 70.5-148.9 75.1-199.6 64.3l-9.8-2.4c-13.8-3.7-26.3-12.1-38.4-23.2zm281.8-82l-199.8 0 80-80 159.1 0c-11.1 28.9-24.2 56.2-39.3 80zm45.2-96l-149 0 56.9-56.9-11.3-11.3-234.9 234.9c-9.5-10.3-17-21-21.3-32.5l-1.9-5.9c-13.5-49.9-13.3-134.2 61.9-209.3l8.3-7.8c43-38.5 108.3-66.3 174.9-85.5 60.6-17.4 120.5-27.2 162.2-31.8-4.6 41.7-14.3 101.7-31.8 162.3-4.3 14.8-8.9 29.5-14.1 43.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFeatherPointed = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;